// ─── Types ──────────────────────────────────────────────────────────
// ─── Initial State ──────────────────────────────────────────────────
export const initialRoomState = {
    roomCode: null,
    phase: 'idle',
    players: [],
    maxPlayers: 4,
    isPrivate: false,
    localPlayerId: null,
    isLoading: false,
    error: null,
};
// ─── Actions ────────────────────────────────────────────────────────
export function setRoomCreating(state) {
    return { ...state, phase: 'creating', isLoading: true, error: null };
}
export function setRoomJoining(state) {
    return { ...state, phase: 'joining', isLoading: true, error: null };
}
export function setRoomJoined(state, roomCode, players, maxPlayers, isPrivate, localPlayerId) {
    return {
        ...state,
        roomCode,
        phase: 'lobby',
        players,
        maxPlayers,
        isPrivate,
        localPlayerId,
        isLoading: false,
        error: null,
    };
}
export function setRoomError(state, error) {
    return { ...state, isLoading: false, error };
}
export function addPlayer(state, player) {
    if (state.players.some((p) => p.id === player.id))
        return state;
    return { ...state, players: [...state.players, player] };
}
export function removePlayer(state, playerId) {
    return { ...state, players: state.players.filter((p) => p.id !== playerId) };
}
export function setPlayerReady(state, playerId, isReady) {
    const players = state.players.map((p) => p.id === playerId ? { ...p, isReady } : p);
    return { ...state, players };
}
export function addAIPlayer(state, playerId, difficulty) {
    const aiPlayer = {
        id: playerId,
        name: `AI (${difficulty.charAt(0).toUpperCase() + difficulty.slice(1)})`,
        isHost: false,
        isReady: true,
        isAI: true,
        aiDifficulty: difficulty,
    };
    return { ...state, players: [...state.players, aiPlayer] };
}
export function setRoomStarting(state) {
    return { ...state, phase: 'starting' };
}
export function leaveRoom() {
    return { ...initialRoomState };
}
export function updateRoomPlayers(state, players) {
    return { ...state, players };
}
export function clearRoomError(state) {
    return { ...state, error: null };
}
//# sourceMappingURL=roomStore.js.map